import axios from '../axios'

/**
 * 图片上传
 * @param {*} data
 */
 export const upload = data => {
  return axios({
    url: '/match/file/upload',
    method: 'post',
    data,
    headers: {
      isToken: false
    }
  })
}
// 获取项目
export const findProgram = data => {
  return axios({
    url: '/club/clubProgram/list',
    method: 'get'
  })
}

// 添加/编辑班级
export const classSave = data => {
  return axios({
    url: '/club/clubClass/save',
    method: 'post',
    data
  })
}

// 查询班级
export const findClass = data => {
  return axios({
    url: '/club/clubClass/list/' + data.agencyId,
    method: 'get'
  })
}

// 查询班级的详情数据
export const findClassDetail = data => {
  return axios({
    url: '/club/clubClass/detail/' + data.agencyId + '/' + data.classId,
    method: 'get'
  })
}

// 查询班级上课时间表
export const findClassTime = data => {
  return axios({
    url: '/club/clubClassTime/list/' + data.agencyId + '/' + data.classId,
    method: 'get'
  })
}

// 删除机构班级
export const classDelete = data => {
  return axios({
    url: '/club/clubClass/delete/' + data.classId,
    method: 'delete'
  })
}

// 查询机构教师
export const findTeacher = data => {
  return axios({
    url: '/club/clubTeacher/listName/' + data.agencyId,
    method: 'get'
  })
}

// 查询机构教师列表
export const teacherList = data => {
  return axios({
    url: '/club/clubTeacher/list/' + data.agencyId,
    method: 'get'
  })
}

// 添加/编辑教师
export const teacherSave = data => {
  return axios({
    url: '/club/clubTeacher/save',
    method: 'post',
    data
  })
}

// 删除机构教师
export const teacherDelete = data => {
  return axios({
    url: '/club/clubTeacher/delete/' + data.id,
    method: 'delete'
  })
}

// 查询机构学员列表
export const studentList = data => {
  return axios({
    url: '/club/clubStudentCard/list/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize + '/' + data.keyWords + '/' + data.sex,
    method: 'get'
  })
}

/**
 * 删除学员
 * @param {*} data
 */
 export const playerDelete = data => {
  return axios({
    url: '/match/player/delete/' + data.id,
    method: 'delete'
  })
}

/**
 * 学员添加/编辑
 * @param {*} data
 */
 export const playerSave = data => {
  return axios({
    url: '/match/player/clubSave',
    method: 'post',
    data
  })
}

/**
 * 学员添加/编辑
 * @param {*} data
 */
 export const studentSave = data => {
  return axios({
    url: '/club/clubStudent/save',
    method: 'post',
    data
  })
}

// 查询学员的详情数据
export const findStudentDetail = data => {
  return axios({
    url: '/club/clubStudent/detail/' + data.agencyId + '/' + data.studentId,
    method: 'get'
  })
}

// 查询学员卡
export const cardList = data => {
  return axios({
    url: '/club/clubCard/list/' + data.agencyId,
    method: 'get'
  })
}

/**
 * 学员卡添加/编辑
 * @param {*} data
 */
 export const cardSave = data => {
  return axios({
    url: '/club/clubCard/save',
    method: 'post',
    data
  })
}

// 删除学员卡
export const cardDelete = data => {
  return axios({
    url: '/club/clubCard/delete/' + data.id,
    method: 'delete'
  })
}

/**
 * 购买学员卡
 * @param {*} data
 */
 export const buyCard = data => {
  return axios({
    url: '/club/clubStudentCard/buyCard',
    method: 'post',
    data
  })
}

// 查询单个学员的学员卡详情
export const studentCard = data => {
  return axios({
    url: '/club/clubStudentCard/studentCard/' + data.agencyId + '/' + data.studentId,
    method: 'get'
  })
}

// 查询年级信息
export const gradeList = data => {
  return axios({
    url: '/clubExamines/grade/list',
    method: 'get'
  })
}

// 冻结学员卡
export const frozenCard = data => {
  return axios({
    url: '/club/clubStudentCard/frozenCard/' + data.id + '/' + data.status,
    method: 'put'
  })
}

// 查询机构班级学员列表
export const classStudentList = data => {
  return axios({
    url: '/club/clubClassStudent/list/' + data.agencyId + '/' + data.classId + '/' + data.keyWords + '/' + data.sex,
    method: 'get'
  })
}

// 班级签到
export const classSign = data => {
  return axios({
    url: '/club/clubClassStudentSign/sign/' + data.agencyId + '/' + data.classId + '/' + data.studentId,
    method: 'get'
  })
}

// 签到缺席
export const classAbsent = data => {
  return axios({
    url: '/club/clubClassStudentSign/absent/' + data.agencyId + '/' + data.classId + '/' + data.studentId + '/' + data.type,
    method: 'get'
  })
}

// 修改学员卡到期时间
export const updExpireTime = data => {
  return axios({
    url: '/club/clubStudentCard/updExpireTime',
    method: 'post',
    data
  })
}

// 修改学员卡
export const updCard = data => {
  return axios({
    url: '/club/clubStudentCard/updCard',
    method: 'post',
    data
  })
}

// 修改学员卡剩余金额
export const updCardMoney = data => {
  return axios({
    url: '/club/clubStudentCard/updCardMoney',
    method: 'post',
    data
  })
}

// 查询单个学员的学员卡扣除记录
export const cardClearLog = data => {
  return axios({
    url: '/club/clubStudentCard/studentCardClearLog/' + data.agencyId + '/' + data.studentId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 查询班级教练签到
export const teacherSignList = data => {
  return axios({
    url: '/club/clubTeacherSign/list/' + data.agencyId + '/' + data.classId + '/' + data.pageNum + '/' + data.pageSize + '/' + data.day,
    method: 'get'
  })
}

// 教师签到
export const teacherSign = data => {
  return axios({
    url: '/club/clubTeacherSign/sign/' + data.agencyId + '/' + data.classId + '/' + data.teacherId + '/' + data.type,
    method: 'get'
  })
}

// 教师补签
export const teacherRepairSign = data => {
  return axios({
    url: '/club/clubTeacherSign/repairSign/' + data.agencyId + '/' + data.classId + '/' + data.teacherId + '/' + data.type + '/' + data.timeId + '/' + data.time,
    method: 'get'
  })
}

// 查询班级上课记录
export const teachLog = data => {
  return axios({
    url: '/club/clubClass/teachLog/' + data.agencyId + '/' + data.classId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 查询班级补签列表
export const repairSignList = data => {
  return axios({
    url: '/club/clubClassStudentSign/repairSignList/' + data.id,
    method: 'get'
  })
}

// 补签
export const repairSign = data => {
  return axios({
    url: '/club/clubClassStudentSign/repairSign/' + data.id + '/' + data.studentId,
    method: 'get'
  })
}


// 查询私教的详情数据
export const findPrivateDetail = data => {
  return axios({
    url: '/club/clubPrivate/detail/' + data.agencyId + '/' + data.privateId,
    method: 'get'
  })
}

// 添加/编辑私教
export const privateSave = data => {
  return axios({
    url: '/club/clubPrivate/save',
    method: 'post',
    data
  })
}

// 查询私教
export const findPrivate = data => {
  return axios({
    url: '/club/clubPrivate/list/' + data.agencyId,
    method: 'get'
  })
}

// 查询私教上课时间表
export const privateTime = data => {
  return axios({
    url: '/club/clubPrivate/privateTime/' + data.agencyId + '/' + data.privateId,
    method: 'get'
  })
}

// 查询预约列表
export const privateAppoint = data => {
  return axios({
    url: '/club/clubPrivate/privateAppoint/' + data.agencyId + '/' + data.privateId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 私教预约处理
export const appointHandle = data => {
  return axios({
    url: '/club/clubPrivate/appointHandle/' + data.agencyId + '/' + data.id + '/' + data.status,
    method: 'get'
  })
}

// 查询单个学员的私教学员卡扣除记录
export const privateClearLog = data => {
  return axios({
    url: '/club/clubStudentCard/privateClearLog/' + data.agencyId + '/' + data.studentId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 添加/编辑团课
export const leagueSave = data => {
  return axios({
    url: '/club/clubLeague/save',
    method: 'post',
    data
  })
}

// 查询团课
export const findLeague = data => {
  return axios({
    url: '/club/clubLeague/list/' + data.agencyId,
    method: 'get'
  })
}

// 查询团课的详情数据
export const findLeagueDetail = data => {
  return axios({
    url: '/club/clubLeague/detail/' + data.agencyId + '/' + data.leagueId,
    method: 'get'
  })
}

// 查询团课上课时间表
export const leagueTime = data => {
  return axios({
    url: '/club/clubLeague/leagueTime/' + data.agencyId + '/' + data.leagueId,
    method: 'get'
  })
}

// 查询团课列表
export const leagueAppoint = data => {
  return axios({
    url: '/club/clubLeague/appointList/' + data.agencyId + '/' + data.leagueId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 删除私教
export const privateDelete = data => {
  return axios({
    url: '/club/clubPrivate/delete/' + data.id,
    method: 'delete'
  })
}

// 删除团课
export const leagueDelete = data => {
  return axios({
    url: '/club/clubLeague/delete/' + data.id,
    method: 'delete'
  })
}

// 查询约课
export const findInvite = data => {
  return axios({
    url: '/club/clubInvite/list/' + data.agencyId,
    method: 'get'
  })
}


// 查询约课的详情数据
export const findInviteDetail = data => {
  return axios({
    url: '/club/clubInvite/detail/' + data.agencyId + '/' + data.inviteId,
    method: 'get'
  })
}

// 添加/编辑约课
export const InviteSave = data => {
  return axios({
    url: '/club/clubInvite/save',
    method: 'post',
    data
  })
}

// 查询约课上课时间表
export const inviteTime = data => {
  return axios({
    url: '/club/clubInvite/inviteTime/' + data.agencyId + '/' + data.inviteId,
    method: 'get'
  })
}

// 查询约课列表
export const inviteAppoint = data => {
  return axios({
    url: '/club/clubInvite/appointList/' + data.agencyId + '/' + data.inviteId,
    method: 'get'
  })
}

// 查询约课学员列表
export const inviteAppointPlayer = data => {
  return axios({
    url: '/club/clubInvite/appointPlayerList/' + data.agencyId + '/' + data.inviteId + '/' + data.timeId,
    method: 'get'
  })
}

// 查询约课学员状态
export const inviteUpdStatus = data => {
  return axios({
    url: '/club/clubInvite/updStatus/' + data.id + '/' + data.status,
    method: 'get'
  })
}

// 查询单个学员的团课学员卡扣除记录
export const leagueClearLog = data => {
  return axios({
    url: '/club/clubStudentCard/leagueClearLog/' + data.agencyId + '/' + data.studentId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 查询单个学员的约课学员卡扣除记录
export const inviteClearLog = data => {
  return axios({
    url: '/club/clubStudentCard/inviteClearLog/' + data.agencyId + '/' + data.studentId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 学员卡流水
export const cardStream = data => {
  return axios({
    url: '/club/clubStudentCard/cardStream/' + data.agencyId + '/' + data.studentId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 学员积分流水
export const studentScoreStream = data => {
  return axios({
    url: '/club/clubStudentCard/scoreStream/' + data.agencyId + '/' + data.studentId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 班级统计
export const classCensus = data => {
  return axios({
    url: '/club/clubClass/census/' + data.agencyId + '/' + data.classId,
    method: 'get'
  })
}

/**
 * 挑战赛添加/编辑
 * @param {*} data
 */
 export const challengeSave = data => {
  return axios({
    url: '/club/clubChallenge/save',
    method: 'post',
    data
  })
}

// 查询机构挑战赛列表
export const challengeList = data => {
  return axios({
    url: '/club/clubChallenge/list/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 查询机构挑战赛排行列表
export const challengeRankList = data => {
  return axios({
    url: '/club/clubChallengeRank/rankList/' + data.agencyId + '/' + data.challengeId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 查询机构挑战赛积分
export const challengeScore = data => {
  return axios({
    url: '/club/clubChallenge/challengeScore/' + data.agencyId + '/' + data.challengeId,
    method: 'get'
  })
}

// 俱乐部添加/编辑挑战赛积分
export const challengeSaveScore = data => {
  return axios({
    url: '/club/clubChallenge/saveScore',
    method: 'post',
    data
  })
}

// 俱乐部添加/编辑挑战赛费用
export const challengeSaveMoney = data => {
  return axios({
    url: '/club/clubChallenge/saveMoney',
    method: 'post',
    data
  })
}

// 查询机构挑战赛费用
export const challengeMoney = data => {
  return axios({
    url: '/club/clubChallenge/challengeMoney/' + data.agencyId + '/' + data.challengeId,
    method: 'get'
  })
}

// 俱乐部生成对战
export const challengeLaunch = data => {
  return axios({
    url: '/club/clubChallengePk/launch',
    method: 'post',
    data
  })
}

// 查询机构挑战赛未支付的
export const challengePayList = data => {
  return axios({
    url: '/club/clubChallengePk/payList/' + data.agencyId + '/' + data.challengeId,
    method: 'get'
  })
}

// 查询机构挑战赛创建支付订单
export const createOrder = data => {
  return axios({
    url: '/club/clubChallengeOrder/createOrder/' + data.pkId + '/' + data.studentId + '/' + data.type,
    method: 'get'
  })
}

/**
 * 查询订单支付状态 {orderNumber}/{orderType}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
 export const queryOrderStatus = data => {
  return axios({
    url: '/club/clubChallengeOrder/queryOrderStatus/' + data.orderNumber,
    method: 'get'
  })
}

// 查询指定运动员挑战赛的战绩
export const studentRank = data => {
  return axios({
    url: '/club/clubChallenge/studentRank/' + data.agencyId + '/' + data.challengeId + '/' + data.studentId,
    method: 'get'
  })
}

// 查询机构挑战赛对战
export const challengeBattle = data => {
  return axios({
    url: '/club/clubChallengePk/battle/' + data.agencyId + '/' + data.challengeId,
    method: 'get'
  })
}

// 查询机构挑战赛判罚
export const challengePenalty = data => {
  return axios({
    url: '/club/clubChallengePk/penalty/' + data.pkId + '/' + data.type,
    method: 'get'
  })
}

// 查询机构配置设置
export const clubSetting = data => {
  return axios({
    url: '/club/clubSetting/setting/' + data.agencyId,
    method: 'get'
  })
}

// 俱乐部配置设置
export const clubSettingSave = data => {
  return axios({
    url: '/club/clubSetting/save',
    method: 'post',
    data
  })
}

/**
 *  导出学员数据
 * @param {*} data
 */
 export const exportDataExcel = data => {
  return axios({
    url: '/club/clubStudent/exportDataExcel/' + data.agencyId + '/' + data.classId,
    method: 'get',
    responseType: 'blob'
  })
}

// 查询机构课消统计
export const clubYearCard = data => {
  return axios({
    url: '/club/clubAgency/yearCard/' + data.agencyId,
    method: 'get'
  })
}

// 查询机构学员卡收入
export const clubYearBuyPrice = data => {
  return axios({
    url: '/club/clubAgency/yearBuyPrice/' + data.agencyId,
    method: 'get'
  })
}

// 查询机构考勤统计
export const clubYearAttend = data => {
  return axios({
    url: '/club/clubAgency/yearAttend/' + data.agencyId,
    method: 'get'
  })
}

// 查询机构手带
export const braceletList = data => {
  return axios({
    url: '/club/clubBracelet/list/' + data.agencyId,
    method: 'get'
  })
}

// 俱乐部添加手带
export const clubBraceletSave = data => {
  return axios({
    url: '/club/clubBracelet/save',
    method: 'post',
    data
  })
}

// 删除手带
export const braceletDelete = data => {
  return axios({
    url: '/club/clubBracelet/delete/' + data.id,
    method: 'delete'
  })
}

// 绑定手带
export const braceletBind = data => {
  return axios({
    url: '/club/clubBraceletUse/bind/' + data.agencyId + '/' + data.studentId + '/' + data.braceletId + '/' + data.classId + '/' + data.type,
    method: 'get'
  })
}

// 取消绑定手带
export const braceletUnBind = data => {
  return axios({
    url: '/club/clubBraceletUse/unBind/' + data.agencyId + '/' + data.studentId + '/' + data.braceletId,
    method: 'get'
  })
}

// 修改积分数据
export const updateStudentScore = data => {
  return axios({
    url: '/club/clubStudentCard/updateStudentScore/' + data.agencyId + '/' + data.studentId + '/' + data.num,
    method: 'put'
  })
}

// 查询推送记录
export const pushList = data => {
  return axios({
    url: '/club/clubStationPush/list/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 添加推送任务
export const savePush = data => {
  return axios({
    url: '/club/clubStationPush/push',
    method: 'post',
    data
  })
}

// 查询推送记录
export const pushStudent = data => {
  return axios({
    url: '/club/clubStationPush/pushStudent/' + data.agencyId + '/' + data.pushId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 添加推送学员
export const addStudent = data => {
  return axios({
    url: '/club/clubStationPush/addStudent',
    method: 'post',
    data
  })
}

// 删除推送绑定
export const delPush = data => {
  return axios({
    url: '/club/clubStationPush/delPush/' + data.pushId + '/' + data.studentId,
    method: 'delete'
  })
}

// 查询推送状态列表
export const pushStudentList = data => {
  return axios({
    url: '/club/clubStationPush/pushList/' + data.agencyId + '/' + data.pushId,
    method: 'get'
  })
}

// 发送推送
export const pushMsg = data => {
  return axios({
    url: '/club/clubStationPush/pushMsg',
    method: 'post',
    data
  })
}

// 删除推送任务
export const delStation = data => {
  return axios({
    url: '/club/clubStationPush/delStation/' + data.id,
    method: 'delete'
  })
}

/**
 * 考级添加/编辑
 * @param {*} data
 */
 export const gradingSave = data => {
  return axios({
    url: '/club/clubGrading/save',
    method: 'post',
    data
  })
}

// 查询机构考级列表
export const gradingList = data => {
  return axios({
    url: '/club/clubGrading/list/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}

// 查询机构考级项目
export const gradingSectionList = data => {
  return axios({
    url: '/club/clubGradingSection/list/' + data.agencyId + '/' + data.gradingId + '/' + data.programId,
    method: 'get'
  })
}

/**
 * 考级添加/编辑
 * @param {*} data
 */
 export const gradingSectionSave = data => {
  return axios({
    url: '/club/clubGradingSection/save',
    method: 'post',
    data
  })
}

// 查询机构考级项目
export const gradingProjectList = data => {
  return axios({
    url: '/club/clubGradingProject/list/' + data.agencyId + '/' + data.sectionId + '/' + data.programId,
    method: 'get'
  })
}

// 查询机构考级项目
export const copyProject = data => {
  return axios({
    url: '/club/clubGradingProject/copyProject/' + data.agencyId + '/' + data.sectionId + '/' + data.gradingId,
    method: 'get'
  })
}

/**
 * 考级添加
 * @param {*} data
 */
 export const clubGradingProjectAdd = data => {
  return axios({
    url: '/club/clubGradingProject/add',
    method: 'post',
    data
  })
}

/**
 * 考级添加
 * @param {*} data
 */
 export const clubGradingProjectItemAdd = data => {
  return axios({
    url: '/club/clubGradingProject/addItem',
    method: 'post',
    data
  })
}

/**
 * 考级修改
 * @param {*} data
 */
 export const clubGradingProjectItemUpdate= data => {
  return axios({
    url: '/club/clubGradingProject/updateItem',
    method: 'post',
    data
  })
}

/**
 * 考级修改
 * @param {*} data
 */
 export const clubGradingProjectTitleUpdate= data => {
  return axios({
    url: '/club/clubGradingProject/updateTitle',
    method: 'post',
    data
  })
}

// 删除考级
export const delGrading = data => {
  return axios({
    url: '/club/clubGrading/delete/' + data.id,
    method: 'delete'
  })
}

// 删除考级项目
export const delGradingSection = data => {
  return axios({
    url: '/club/clubGradingSection/delete/' + data.id,
    method: 'delete'
  })
}

// 修改考级项目的金额
export const updateSectionMoney = data => {
  return axios({
    url: '/club/clubGradingSection/updMoney',
    method: 'post',
    data
  })
}

// 删除考级项目
export const delGradingProject = data => {
  return axios({
    url: '/club/clubGradingProject/deleteProject/' + data.id,
    method: 'delete'
  })
}

// 删除考级项目
export const delGradingProjectItem = data => {
  return axios({
    url: '/club/clubGradingProject/deleteProjectItem/' + data.id,
    method: 'delete'
  })
}

// 查询考级报名人员
export const gradingJoin = data => {
  return axios({
    url: '/club/clubGrading/gradingJoin/' + data.agencyId + '/' + data.gradingId,
    method: 'get'
  })
}

// 查询考级报名人员
export const exportGradingDataExcel = data => {
  return axios({
    url: '/club/clubGrading/exportGradingDataExcel/' + data.agencyId + '/' + data.gradingId,
    method: 'get',
    responseType: 'blob'
  })
}

// 导出考级编排数据
export const exportSectionDataExcel = data => {
  return axios({
    url: '/club/clubGradingLayout/exportSectionDataExcel/' + data.agencyId + '/' + data.gradingId + '/' + data.sectionId,
    method: 'get',
    responseType: 'blob'
  })
}

// 查询考级编排情况
export const findGradingLayOut = data => {
  return axios({
    url: '/club/clubGradingSection/layList/' + data.gradingId,
    method: 'get'
  })
}

// 查询考级考官
export const findGradingReferee = data => {
  return axios({
    url: '/club/clubGradingReferee/list/'  + data.agencyId + '/' + data.gradingId,
    method: 'get'
  })
}

// 俱乐部添加考官
export const gradingRefereeAdd = data => {
  return axios({
    url: '/club/clubGradingReferee/add',
    method: 'post',
    data
  })
}

// 删除考级考官
export const delGradingReferee = data => {
  return axios({
    url: '/club/clubGradingReferee/delete/' + data.id,
    method: 'delete'
  })
}

// 俱乐部考级编排
export const gradingRefereeLayout = data => {
  return axios({
    url: '/club/clubGradingLayout/layout',
    method: 'post',
    data
  })
}

// 查询考级项目
export const sectionList = () => {
  return axios({
    url: '/club/clubGradingReferee/sectionList',
    method: 'get'
  })
}

// 删除考级比那批
export const delGradingLayout = data => {
  return axios({
    url: '/club/clubGradingLayout/delete/' + data.gradingId + '/' + data.sectionId,
    method: 'delete'
  })
}

// 查询考级运动员
export const sectionPlayer = data => {
  return axios({
    url: '/club/clubGradingReferee/sectionPlayer/'  + data.sectionId,
    method: 'get'
  })
}

// 根据场次号查询考级运动员
export const searchField = data => {
  return axios({
    url: '/club/clubGradingReferee/searchField/'  + data.sectionId + '/' + data.fieldNum,
    method: 'get'
  })
}

// 俱乐部考级提交
export const gradingRefereeSubmit = data => {
  return axios({
    url: '/club/clubGradingReferee/submit',
    method: 'post',
    data
  })
}

// 取消学员的考级项目
export const cancelSection = data => {
  return axios({
    url: '/club/clubGradingSection/cancelSection/'  + data.studentId + '/' + data.gradingId + '/' + data.sectionId,
    method: 'get'
  })
}

// 查询俱乐部统计
export const agencyCensus = data => {
  return axios({
    url: '/club/clubAgency/census/'  + data.agencyId,
    method: 'get'
  })
}

// 查询收支明细
export const incomeList = data => {
  return axios({
    url: '/club/clubIncome/list/'  + data.agencyId,
    method: 'get'
  })
}

// 查询本月收支明细
export const monthIncome = data => {
  return axios({
    url: '/club/clubIncome/monthIncome/'  + data.agencyId,
    method: 'get'
  })
}

// 添加收支明细
export const incomeSave = data => {
  return axios({
    url: '/club/clubIncome/save',
    method: 'post',
    data
  })
}

// 查询分馆列表
export const clubParentList = data => {
  return axios({
    url: '/club/clubParent/list/'  + data.agencyId,
    method: 'get'
  })
}

// 查询分馆列表
export const clubParentBindGuan = data => {
  return axios({
    url: '/club/clubParent/bindGuan',
    method: 'post',
    data
  })
}

// 个人中心修改机构信息
export const updateAgency = data => {
  return axios({
    url: '/agency/agencyInfo/update',
    method: 'post',
    data
  })
}

// 查询分馆列表
export const clubParentUnBindGuan = data => {
  return axios({
    url: '/club/clubParent/unBindGuan/'  + data.agencyId + '/' + data.parentId,
    method: 'get'
  })
}

// 查询该机构是否具备创建分馆或添加分馆的权限
export const clubParentAuth = data => {
  return axios({
    url: '/club/clubParent/authGuan/'  + data.agencyId,
    method: 'get'
  })
}

// 注册分馆
export const clubGuanRegister = data => {
  return axios({
    url: '/agency/agencyMatch/clubGuanRegister',
    method: 'post',
    data
  })
}

// 根据名字查询机构
export const findAgencyByName = data => {
  return axios({
    url: '/agency/agencyInfo/findAgencyByName/'  + data.unitName,
    method: 'get'
  })
}

// 俱乐部添加/编辑商品
export const clubShopSave = data => {
  return axios({
    url: '/club/clubShop/save',
    method: 'post',
    data
  })
}

// 查询该俱乐部下面的商品
export const clubShopList = data => {
  return axios({
    url: '/club/clubShop/list',
    method: 'post',
    data
  })
}

// 查询商品详情
export const clubShopDetail = data => {
  return axios({
    url: '/club/clubShop/detail/'  + data.id,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/club.js